import _ from 'underscore';
import { ProjectionGridBaseColumn } from '@bingads-webui/projection-grid-base-column';
import { formatInteger } from '@bingads-webui-campaign/recommendation-core';
import template from './one-line-text.pug';

export class NumberOfRecommendationColumn extends ProjectionGridBaseColumn {
  constructor({ i18n }) {
    const title = i18n.getString('ColumnName_NumberOfRecommendation');
    super({
      name: 'NumberOfRecommendation',
      property: 'RecommendationResult/NumberOfRecommendation',
      title,
      bodyClasses: ['grid-column-number-of-recommendation'],
      colClasses: ['col-text'],
      type: 'number',
      helpId: 'Pop_BA_Recommendations_MCC_TotalRec',
      helpAriaLabel: i18n.getString('Click to learn more about {{item}}', { item: title }),
    });

    this.i18n = i18n;
  }

  template({
    value: {
      TotalRecommendationCount,
    },
  }) {
    return template({
      content:
        _.isNull(TotalRecommendationCount) ?
          this.i18n.getString('In_Progress') :
          formatInteger(TotalRecommendationCount, this.i18n),
    });
  }

  get property() {
    return {
      get: _.identity,
      key: 'RecommendationResult/NumberOfRecommendation',
    };
  }
}
